<template>
  <a-modal
    :visible="visible"
    :width="500"
    title="选择订单"
    @cancel="visible = false"
    :footer="null"
  >
    <div style="max-height:calc(70vh);overflow-y:auto">
      <div
        v-for="item in orderList"
        :key="item.OrderId"
        class="select-order-item"
        @click="onSelect(item)"
      >
        <div>
          <span
            >姓名：{{ item.GuestName }}
            <a-tag
              v-if="item.Status == 2 || item.Status == 3"
              :color="
                item.Status == 2 ? '#43bf06' : item.Status == 3 ? '#f9974c' : ''
              "
              >{{
                item.Status == 2 ? "离店" : item.Status == 3 ? "暂离" : ""
              }}</a-tag
            ></span
          >
          <span>电话：{{ item.Phone ? item.Phone : "未填写" }}</span>
        </div>
        <div>
          <span>
            住离日期：{{
              defaultItem.isShowTime || item.IsHourRoom
                ? moment(item.CheckInTime).format("YYYY-MM-DD HH:mm")
                : item.CheckInDate
            }}
            至
            {{
              defaultItem.isShowTime || item.IsHourRoom
                ? moment(item.CheckOutTime).format("YYYY-MM-DD HH:mm")
                : moment(item.CheckOutTime, "YYYY-MM-DD").diff(
                    item.CheckOutDate
                  )
                ? moment(item.CheckOutTime).format("YYYY-MM-DD")
                : item.CheckOutDate
            }}
          </span>
          <span
            >房租：<span style="color:#f00"> &yen;{{ item.Rent }}</span></span
          >
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  components: {},
  props: {
    orderList: {
      type: Array,
      default: () => []
    },
    submit: { type: Function },
    defaultItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visible: true
    };
  },
  created() {
    this.visible = true;
  },
  mounted() {},
  methods: {
    onCancel() {
      this.visible = false;
    },
    onSelect(item) {
      this.$emit("submit", item);
      this.visible = false;
    }
  }
};
</script>
<style scoped lang="less">
.select-order-item {
  padding: 15px 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  margin-bottom: 10px;
  border-top: 3px solid #999;
  line-height: 34px;
  & > div {
    display: flex;
    justify-content: space-between;
  }
  &:hover {
    border-color: #40a9ff;
    cursor: pointer;
  }
}
</style>
